module.exports = __webpack_public_path__ + "assets/b3224a01db54a59d7627867e32a4d2bd.png";